import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link } from 'react-router-dom';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

import InputMask from 'react-input-mask';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import getLocale from '../../i18n/getLocale';

// Importo o moment com a linguagem pt-br
require('moment');
require('moment/locale/pt-br');

class FlightsAdd extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',        
      },
      redirect_url: false,
      loaded: 0,
      aircraft_models: [],
      bases: [],
      justifications_ptbr: [],
      codes_ptbr: [],
      justifications_omni: [],
      flight_types: [],
      flights: [],
      totals: [],
      today: '0000-00-00',
      aircraft_id: null,
      base_id: null,
      reason: null,
      session: null,
      date: null,
      date_start: null,
      date_finish: null,
      delay: null,
      delay_result: 0,
      delay_update: 0,
      type_update: 0,
      justification_omni_selected: 0,
      justification_ptbr_selected: 0,
      scheduled_departure: null,
      actual_departure: null,
      code_ptbr: null,
      justification_ptbr: null,
      justification_omni: null,
      flight_type: null,
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.locale = getLocale();

    this.add = this.add.bind(this);
    this.delete = this.delete.bind(this);
    this.loadData = this.loadData.bind(this);
    this.refreshFlights = this.refreshFlights.bind(this);
  }

  // Handlers
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleSelectChangeType(name, event) {
    var change = {};
    if(event === null) {
      change[name] = null;
      this.setState({type_update: 1});
    } else {
      change[name] = event.value;
      if (event.value === "PTBR") {
        this.setState({justification_ptbr_selected: 1});
        this.setState({justification_omni_selected: 0});
      } else {
        this.setState({justification_ptbr_selected: 0});
        this.setState({justification_omni_selected: 1});
        this.setState({justification_ptbr: null});
        this.setState({code_ptbr: null});
      }
    }
    this.setState(change);
  }

  handleSelectChangeJustificationPtbr(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
      this.clearJustificationPtbr();
    } else {
      this.handleAlert('', '', 'open');
      change[name] = event.value;

      var datasave = {
        justification_ptbr: event.value,
      };

      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/justificativas/ptbr/codigos/lista', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
            self.setState({codes_ptbr: responseJson.data});
            self.handleAlert(responseJson.message, responseJson.status, 'closed');
        }).catch((error) => {
          console.error(error);
        });
      });
    }
    this.setState(change);
  }

  handleSelectChangeJustificationOmni(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
      this.clearJustificationOmni();
    } else {
      this.handleAlert('', '', 'open');
      change[name] = event.value;

      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        var url = config.get('api') + '/justificativa/omni/selecionada/'+event.value;
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.setState({reason: responseJson.data.reason});
          self.setState({session: responseJson.data.session});
          self.handleAlert(responseJson.message, responseJson.status, 'closed');
        }).catch((error) => {
          console.error(error);
        });
      });      
    }
    this.setState(change);
  }

  handleChangeDelay(name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
    this.setState({delay_update: 1});
  }

  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event;
    }
    this.setState(change);
  }

  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  handleChangeDatePicker (state, date) {
    var change = {};
    change[state] = date.format("DD/MM/YYYY");
    this.setState(change);
  } 
  
  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});      
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  // Setamos o state.date_start para a data de hoje
  componentWillMount () {
      var today = new Date().toISOString().slice(0,10);
      var today_str = new Date().toJSON().slice(0,10).split('-').reverse().join('/');

      this.setState({date: today_str});
      this.setState({date_start: today_str});
      this.setState({date_finish: today_str});
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
    if(this.state.delay_update === 1) {
      this.verifyDelay();
      this.setState({delay_update: 0});
    }
    if(this.state.type_update === 1) {
      this.clearJustificationPtbr();
      this.clearJustificationOmni();
      this.setState({justification_omni_selected: 0});
      this.setState({justification_ptbr_selected: 0});
      this.setState({type_update: 0});
    }
  }

  refreshFlights(event) {
    this.handleAlert('', '', 'open');
    var datasave = {
      date_start: this.state.date_start,
      date_finish: this.state.date_finish,
      bases_id: this.state.bases_id,
    };

    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/voos', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({flights: responseJson.data.bases});
        }
        self.handleAlert(event.message, event.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  loadData() {
    var self = this;
    var header = this.refs.request_api.header('application/json');

    var datasave = {
      date_start: this.state.date_start,
      date_finish: this.state.date_finish,
    };
    
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/voos', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        if (responseJson.status === 'success') {
          self.refs.request_api.validate(responseJson, 'alert');
          self.setState({flights: responseJson.data.bases});
        }
      }).then(() => {
      var url = config.get('api') + '/aeronaves/modelo/registro/lista';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({aircraft_models: responseJson.data});
        }
      var url = config.get('api') + '/bases/lista';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({bases: responseJson.data});
        }
      var url = config.get('api') + '/justificativas/ptbr/lista';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({justifications_ptbr: responseJson.data});
        }
      var url = config.get('api') + '/justificativas/omni/lista';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({justifications_omni: responseJson.data});
        }
      var url = config.get('api') + '/voos/tipos/lista';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({flight_types: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); /* Overlay */  }); /* aeronave-modelo lista */}); /* Lista bases */ }); /* justificativas ptbr*/ }); /* justifications_omni */}); /* tipos de voos */
    });
  }

  clearJustificationPtbr() {
    this.setState({justification_ptbr: null});
    this.setState({code_ptbr: null});
  }

  clearJustificationOmni() {
    this.setState({justification_omni: null});
    this.setState({'reason': ''});
    this.setState({'session': ''});
  }
  changeStateAndclearJustifications() {
    this.setState({delay: ''});
    this.setState({delay_result: 0});
    this.setState({justification_omni: null});
    this.setState({'reason': ''});
    this.setState({'session': ''});
    this.setState({justification_ptbr: null});
    this.setState({code_ptbr: null});
    this.handleAlert('', '', 'closed');
  }

  add(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      date_start: this.state.date_start,
      aircraft_id: this.state.aircraft_id,
      base_id: this.state.base_id,
      reason: this.state.reason,
      date: this.state.date,
      actual_departure: this.state.actual_departure,
      scheduled_departure: this.state.scheduled_departure,
      session: this.state.session,
      code: this.state.code_ptbr,
      delay: this.state.delay,
      justification_ptbr: this.state.justification_ptbr,
      justification_omni: this.state.justification_omni,
      type: this.state.flight_type,
    };

    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/voo/cadastrar', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.refreshFlights(responseJson);
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  verifyDelay(event) {
    if (this.state.actual_departure !== null && this.state.scheduled_departure !== null) {
      if (this.state.actual_departure.length === 5 && this.state.scheduled_departure.length === 5) {
        this.handleAlert('', '', 'open');
        var datasave = {
          actual_departure: this.state.actual_departure,
          scheduled_departure: this.state.scheduled_departure,
        };

        var header = this.refs.request_api.header('application/json');
        var self = this;
        Promise.resolve(header).then(function(value) {
          fetch(config.get('api') + '/voo/verificar/atraso', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
            if (responseJson.data.result === 1) {
              self.setState({delay: responseJson.data.delay});
              self.setState({delay_result: responseJson.data.result});
              self.handleAlert(responseJson.message, responseJson.status, 'closed');            
            } else {
              self.changeStateAndclearJustifications();
            }
          }).catch((error) => {
            console.error(error);
          });
        });
      }
    }
  }

  delete (event) {
    var flight_id = event.currentTarget.value;
    var confirm = window.confirm(this.locale.Voos.EditarVoos.deletar);
    if (confirm) {
      this.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/voo/' + flight_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.refreshFlights(responseJson);
          }
        }).catch((error) => {
          console.error(error);
        });
      });      
    }
  }

  render() {
    var self = this;
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">{this.locale.Voos.EditarVoos.titulo} - {this.state.date_start}</h3>
      <Link to="/voos/resumo" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> {this.locale.Voos.EditarVoos.botaoResumoDeVoos}</Link>
      <div className="clearfix"></div>
      <hr/>
      <form onSubmit={this.add}>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Voos.EditarVoos.formulario.Data}:</label>
              <DatePicker value={this.state.date} onChange={this.handleChangeDatePicker.bind(this, 'date')} className="form-control" />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Voos.EditarVoos.formulario.Base}:</label>
              <Select
                className=""
                name="base_id"
                value={this.state.base_id}
                searchable={true}
                placeholder={this.locale.Voos.EditarVoos.formulario.placeholder.SelecionarBase}
                onChange={this.handleSelectChange.bind(this, 'base_id')}
                options={this.state.bases}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Voos.EditarVoos.formulario.Aeronave}:</label>
              <Select
                className=""
                name="aircraft_id"
                value={this.state.aircraft_id}
                searchable={true}
                placeholder={this.locale.Voos.EditarVoos.formulario.placeholder.SelecionarAeronave}
                onChange={this.handleSelectChange.bind(this, 'aircraft_id')}
                options={this.state.aircraft_models}
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Voos.EditarVoos.formulario.TipoDeVoo}:</label>
              <Select
                className=""
                name="flight_type"
                value={this.state.flight_type}
                searchable={true}
                placeholder={this.locale.Voos.EditarVoos.formulario.placeholder.SelecionarBase}
                onChange={this.handleSelectChangeType.bind(this, 'flight_type')}
                options={this.state.flight_types}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.Voos.EditarVoos.formulario.SaidaPrevista}:</label>
              <InputMask value={this.state.scheduled_departure} maskChar={null} name="scheduled_departure" mask="99:99" className="form-control" onChange={this.handleChangeDelay.bind(this, 'scheduled_departure')} placeholder={this.locale.Voos.EditarVoos.formulario.placeholder.Formato} />
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.Voos.EditarVoos.formulario.SaidaReal}:</label>
              <InputMask value={this.state.actual_departure} maskChar={null} name="actual_departure" mask="99:99" className="form-control" onChange={this.handleChangeDelay.bind(this, 'actual_departure')} placeholder={this.locale.Voos.EditarVoos.formulario.placeholder.Formato} />
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.Voos.EditarVoos.formulario.Atraso}:</label>
              <InputMask value={this.state.delay} maskChar={null} name="delay" mask="999" className="form-control" disabled="disabled" />
            </div>
          </div>
        </div>
        {(this.state.delay_result === 1) ? 
            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label>{this.locale.Voos.EditarVoos.formulario.JustificativaOMNI}:</label>
                  <Select
                    className=""
                    name="justification_omni"
                    value={this.state.justification_omni}
                    searchable={true}
                    placeholder={''}
                    onChange={this.handleSelectChangeJustificationOmni.bind(this, 'justification_omni')}
                    options={this.state.justifications_omni}
                  />
                </div>
              </div>
            </div>
          : ""
        }
        {(this.state.delay_result === 1 && this.state.justification_ptbr_selected === 1) ? 
            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label>{this.locale.Voos.EditarVoos.formulario.JustificativaPTBR}:</label>
                  <Select
                    className=""
                    name="justification_ptbr"
                    value={this.state.justification_ptbr}
                    searchable={true}
                    placeholder={''}
                    onChange={this.handleSelectChangeJustificationPtbr.bind(this, 'justification_ptbr')}
                    options={this.state.justifications_ptbr}
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label>{this.locale.Voos.EditarVoos.formulario.CodigoPTBR}:</label>
                  <Select
                    className=""
                    name="code_ptbr"
                    value={this.state.code_ptbr}
                    searchable={true}
                    placeholder={''}
                    onChange={this.handleSelectChange.bind(this, 'code_ptbr')}
                    options={this.state.codes_ptbr}
                  />
                </div>
              </div>
            </div>
          : ""
        }
        <hr/>
        <button type="submit" className="btn btn-primary btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.Voos.EditarVoos.formulario.botaoSalvarVoo}</button>
      </form>
      <hr/>
      <h3 className="page-title">{this.locale.Voos.EditarVoos.tituloVoosPara(this.state.date_start, this.state.date_finish)}</h3>
      <hr/>
      {Object.keys(self.state.flights).map(function(base) {
        return (
          <div>
            <h4>{base}</h4>
            <ul>
              {Object.keys(self.state.flights[base]).map(function(k) {
                return (
                  <div>
                    <li>- <strong>{self.state.flights[base][k].aircraft}</strong> <button className="btn btn-sm btn-danger" value={self.state.flights[base][k].id} onClick={self.delete}><i className="fa fa-fw fa-trash"></i></button></li>
                    {(self.state.flights[base][k].delay_str == "Sim") ?
                      <li>- <strong>{self.locale.Voos.EditarVoos.listaVoosPara.Atrasado}:</strong> <span className="label label-danger">{self.state.flights[base][k].delay_str}</span></li> 
                      : <li>- <strong>{self.locale.Voos.EditarVoos.listaVoosPara.Atrasado}:</strong> <span className="label label-primary">{self.state.flights[base][k].delay_str}</span></li>
                    }
                    <li>- <strong>{self.locale.Voos.EditarVoos.listaVoosPara.SaidaPrevista}:</strong> {self.state.flights[base][k].scheduled_departure_str}</li>
                    <li>- <strong>{self.locale.Voos.EditarVoos.listaVoosPara.SaidaReal}:</strong> {self.state.flights[base][k].actual_departure_str}</li>
                    {(self.state.flights[base][k].delay > 5) ?
                      <li>- <strong>Atraso:</strong> <span className="label label-danger">{self.state.flights[base][k].delay_hr}</span></li> 
                      : ""
                    }
                    {(self.state.flights[base][k].justification_ptbr !== null) ?
                      <div>
                        <li>- <strong>{self.locale.Voos.EditarVoos.listaVoosPara.JustificativaPTBR}:</strong> {self.state.flights[base][k].justification_ptbr}</li>
                        <li>- <strong>{self.locale.Voos.EditarVoos.listaVoosPara.Motivo}:</strong> {self.state.flights[base][k].reason_ptbr}</li>
                        <li>- <strong>{self.locale.Voos.EditarVoos.listaVoosPara.Codigo}:</strong> {self.state.flights[base][k].code}</li>
                      </div>
                      : ""
                    }
                    {(self.state.flights[base][k].justification_omni !== null) ?
                      <div>
                        <li>- <strong>{self.locale.Voos.EditarVoos.listaVoosPara.JustificativaOmni}:</strong> {self.state.flights[base][k].justification_omni}</li>
                        <li>- <strong>{self.locale.Voos.EditarVoos.listaVoosPara.Motivo}:</strong> {self.state.flights[base][k].reason}</li>
                        <li>- <strong>{self.locale.Voos.EditarVoos.listaVoosPara.Setor}:</strong> {self.state.flights[base][k].session}</li>
                      </div>
                      : ""
                    }
                    <hr/>
                  </div>
                );
              })}           
            </ul>
            <hr/>
          </div>
        );
      })}
    </div>
  </div>
</div>
    );
  }
}

export default FlightsAdd;



// WEBPACK FOOTER //
// ./src/Components/Flights/FlightsAdd.js